import { computed, onMounted, ref } from 'vue';
import { Store } from 'vuex';
import { useRoute } from 'vue-router/composables';
import { memberRoute } from '@/router/coach';
import { Member } from '@/models/member';
import { Group } from '@/models/group';
import { Route } from 'vue-router';
import { orderBy } from 'lodash';
import moment from 'moment';

export function useGroupMembers(store: Store<any>) {
  const route = useRoute();

  const groupId = computed<number>(() => {
    return parseInt(route.params.groupId);
  });

  const groupLink = computed<Route>(() => {
    return { path: memberRoute + '/' + groupId.value } as Route;
  });

  const groupMembers = computed<Array<Member>>(() => {
    // default sort order is by firstname
    return orderBy(
      store.getters['groupMembers/groupMembers'],
      (member: Member) => member.firstname.toLowerCase(),
      'asc'
    );
  });

  const groupTotal = computed<string>(() => {
    const totalGroupMembers = groupMembers.value.length;
    const groupMembersPresent = groupMembers.value.filter((member: Member) => member.in).length;
    return `${groupMembersPresent}/${totalGroupMembers}`;
  });

  const group = computed<Group>(() => {
    return store.getters['groups/groupById'](groupId.value) as Group;
  });

  const groupName = computed<string>(() => {
    const name = store.getters['nav/groupName'];
    if (group.value.start_at) {
      return `${moment(group.value.start_at).format('HH:mm')} ${name}`;
    }
    return name;
  });

  const groupDate = computed<string>(() => {
    return (group.value.start_at ? moment(group.value.start_at) : moment()).format('YYYY-MM-DD');
  });

  onMounted(async () => {
    await store.dispatch('groupMembers/fetchMembersByGroupId', groupId.value);
  });

  return { groupId, groupLink, groupName, groupDate, groupTotal, group, groupMembers };
}
